import { render, staticRenderFns } from "./leads-report-table.vue?vue&type=template&id=199f540a&scoped=true"
import script from "./leads-report-table.vue?vue&type=script&lang=js"
export * from "./leads-report-table.vue?vue&type=script&lang=js"
import style0 from "./leads-report-table.vue?vue&type=style&index=0&id=199f540a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f540a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199f540a')) {
      api.createRecord('199f540a', component.options)
    } else {
      api.reload('199f540a', component.options)
    }
    module.hot.accept("./leads-report-table.vue?vue&type=template&id=199f540a&scoped=true", function () {
      api.rerender('199f540a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/leads/components/tables/leads-report-table.vue"
export default component.exports